import type { UserManager } from 'oidc-client-ts';
import type React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext({});

export const LanguageProvider = ({
  children,
  userManager,
}: {
  children: React.ReactNode;
  userManager: UserManager;
}) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const setUserLanguage = async () => {
      const user = await userManager.getUser();
      const locale = user?.profile?.locale || 'fr';
      if (i18n.language !== locale) {
        await i18n.changeLanguage(locale);
        setLanguage(locale);
      }
    };

    setUserLanguage();

    userManager.events.addUserLoaded(setUserLanguage);

    return () => {
      userManager.events.removeUserLoaded(setUserLanguage);
    };
  }, [i18n, userManager]);

  return <LanguageContext.Provider value={{ language }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
